import { useQuery } from "@tanstack/react-query";
import { getAllContactPersons } from "../../api/contactPersons";

const useContactPersons = () => {
  // Keep the overview query separate from detail queries so list refreshes stay cheap.
  const { data, isLoading } = useQuery({
    queryKey: ["contactPersons"],
    queryFn: () => getAllContactPersons(),
  });

  const allContactPersons = data?.data || [];

  return { allContactPersons, isLoading };
};

export default useContactPersons;
